'use strict';
import { Component} from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationBarContent } from './notification-bar-content';
import { NotificationBarItem } from './notification-bar-item';
import { Link } from '../core';
import { NotificationIconTypes } from './notification-icon.component';

@Component({
    selector: 'notification-bar',
    template: require('./notification-bar.component.html')
})
export class NotificationBarComponent {
    public notificationBarItems: Observable<NotificationBarItem[]>;
    public helpCenterLink: Link;
    public notificationIconTypes = NotificationIconTypes;

    constructor(
        private notificationBarContent: NotificationBarContent
    ) {
        this.notificationBarItems = this.notificationBarContent.items;
    }
}